.CartTemplateContainer
    position: fixed
    width: 500px
    max-height: calc(100% - 40px)
    display: flex
    margin: 0
    padding: 20px 20px 10px
    border-radius: $globalSettingsRounding
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    background-color: rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box
    box-shadow: $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05)
    overflow: hidden
    z-index: $indexCart
    animation: 0.3s ease-in-out 0s 1 normal none running openCart
    @media #{$mobile}
        max-height: calc(100% - 10px)
        width: 100%
        top: unset !important
        bottom: 0 !important
        left: 0 !important
        right: 0 !important
        border-radius: $globalSettingsRounding $globalSettingsRounding 0 0
        box-shadow: none

.CartWithContent
    min-height: min(640px, calc(100% - 40px))
    @media #{$mobile}
        min-height: min(640px, calc(100% - 10px))
.CartEmpty
    padding: 20px

.InsideCheckout
    top: 30%
    right: 20px
    left: 20px
    bottom: 20px
    padding: 20px
    width: unset
    max-width: unset
    max-height: 680px
    box-shadow: none
    animation: 0.3s ease-in-out 0s 1 normal none running openCartCheckout

@keyframes openCart
    0%
        opacity: 0
        transform: translateY($globalCartViewTranslate)
    100%
        opacity: 1
        transform: translateY(0)

@keyframes openCartCheckout
    0%
        opacity: 0
        transform: translateY(20px)
    100%
        opacity: 1
        transform: translateY(0)

.InnerContainer
    max-width: 100%
    flex-grow: 1
    display: flex
    flex-direction: column
    min-height: 0
    .CartContent
        width: calc(100% + 40px)
        min-height: 200px
        margin: 0 -20px
        display: flex
        flex-direction: column
        flex-grow: 1
        border-top: 1px solid rgb($globalSettingsStrokeTertiary)
        border-bottom: 1px solid rgb($globalSettingsStrokeTertiary)

\rentware-cart-template-articles
    min-height: 0
    padding: 0 20px
    display: flex
.ArticlesContainer
    width: 100%
    max-width: 100%
    min-height: 0
    margin-right: -6px // for scroll position
    padding-right: 6px // for scroll position
    overflow-x: hidden
    overflow-y: auto
.ArticlesContainerDetails
    width: 100%
    min-height: 0
    height: 100%
    overflow-x: hidden
    overflow-y: auto
    .ShippingDetailsWrapper
        padding: 0 20px

//modal
.CartTemplateModal
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    background: rgb($globalSettingsFontPrimary)
    cursor: pointer
    z-index: $indexOverlay
    opacity: 0.8
    animation: 0.3s ease-in-out 0s 1 normal none running openModal

@keyframes openModal
    0%
        opacity: 0
    100%
        opacity: 0.8

.Summary
    width: 100%
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: flex-end
    font-size: 14px
    span.Total
        font-weight: 700
.SummaryDeposit
    display: flex
    justify-content: flex-end
    font-size: .75rem

.ActionContainer
    width: calc(100% + 40px)
    height: 60px
    margin-left: -20px
    margin-right: -20px
    margin-bottom: -20px
    background: rgba($globalCartColorsStatusBar, 0.75)
    border-radius: $globalSettingsRounding
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    box-sizing: border-box
    //overflow: hidden
    z-index: $indexCart
    .ButtonContainer
        height: 100%
        max-width: 40%
        position: relative
        display: flex
        align-items: center
        margin: 0 10px
    .CartContainer
        display: flex
        flex-direction: row
        flex: 1
        align-items: center

    .InsideCheckout
        right: 20px
        left: 20px
        bottom: 20px
        width: unset
        max-width: unset
        max-height: 680px

    .CartTemplateModal
        display: none
    .CartTemplateModal.InsideCheckoutModal
        max-height: unset
        display: unset
        position: fixed
        top: 0
        left: 0
        right: 0
        bottom: 0
        background: linear-gradient(180deg, rgb(0, 0, 0, 0) 0%, rgba($globalSettingsFontPrimary, 0.6) 100%)
        cursor: pointer
        z-index: $indexOverlay

    .OpenModal.InsideCheckoutModal
        opacity: 1
    .ClosedModal.InsideCheckoutModal
        opacity: 0
